import React from "react";
import { InviteContainer } from "../InviteContainer/InviteContainer";
import { SupplierInviteContent } from "./SupplierInviteContent";
import { SignUpContainer } from "../SignUpContainer";
import useStyles from "./styles";
import { useSupplierInvite } from "./userSupplierState";

export const SupplierAcceptOrDeclineInvitePage = () => {
  const { state, actions, translate } = useSupplierInvite();
  
  const classes = useStyles({
    isExpiredOrInvalidOrRejected: state.isExpiredOrInvalidOrRejected,
  });

  const content = SupplierInviteContent({
    state,
    actions,
    translate,
    classes,
  });

  if (state.showPasswordPage) {
    return (
      <SignUpContainer
        showCompletedPage={state.supplierInvited}
        loading={state.isLoadingInviteSupplier}
        handleSubmitPassword={actions.handleSubmit}
      />
    );
  }

  return (
    <InviteContainer
      title={content.title}
      description={content.description}
      actions={content.actions}
      isExpiredOrInvalid={state.isInvalidToken || state.isExpiredToken}
    />
  );
};
